import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { FormAlert, InputText, handleFormError } from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import validate from '@saucelabs/sl-util-validate';

import { CHANGE_EMAIL_FORM } from './../ducks/types';


const ChangeEmailForm = ({ error, handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <FormAlert type="danger">{error}</FormAlert>
    <Row>
      <Col xs={12}>
        <Field
          className="form-control"
          component={InputText}
          label="New Email"
          name="email"
          type="email"
        />
      </Col>
    </Row>
  </form>
);

ChangeEmailForm.propTypes = {
  error: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
};

ChangeEmailForm.defaultProps = {
  error: undefined,
};

const constraints = {
  email: {
    presence: { allowEmpty: false },
    email: true,
  },
};

const ChangeEmailFormWrapper = reduxForm({
  form: CHANGE_EMAIL_FORM,
  validate: (values) => validate(values, constraints),
  onSubmit: (values, dispatch, formProps) => (
    formProps.changeEmail(values)
      .catch(({ response }) => {
        handleFormError({
          dispatch,
          status: response.status,
          errors: {},
          message40x: response.data.message,
        });
      })
  ),
})(ChangeEmailForm);

ChangeEmailFormWrapper.propTypes = {
  changeEmail: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    username: PropTypes.string,
  }).isRequired,
  settings: PropTypes.object,
};

ChangeEmailFormWrapper.defaultProps = {
  settings: {},
};

export default ChangeEmailFormWrapper;
export { ChangeEmailFormWrapper, ChangeEmailForm };
